import SignUpForm from "../components/SignUpForm";

const SignUp = () => {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 p-8">
      <SignUpForm />
    </div>
  );
};

export default SignUp;
